// extracted by css-extract-rspack-plugin
export default {"pane":"Conversations-module__pane__fH1eo_a"};